import { useRef, useState } from "react";
import { toPng } from "html-to-image";
import { Loader2, Share2 } from "lucide-react";
import { toast } from "sonner";

const fmtDate = (d) => (d ? new Date(`${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6, 8)}T12:00:00`).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" }) : "");

function ShareCard({ slip, date }) {
  return (
    <div style={{ width: 1080, padding: 72, background: "#0A0A0A", color: "#fff", fontFamily: "Inter, Arial, sans-serif" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 44, fontWeight: 900, letterSpacing: -1 }}>GOAL<span style={{ color: "#39FF14" }}>.AI</span></div>
        <div style={{ fontSize: 26, color: "#A1A1AA" }}>{fmtDate(date)}</div>
      </div>
      <div style={{ marginTop: 56, fontSize: 30, color: "#39FF14", fontWeight: 800, textTransform: "uppercase", letterSpacing: 3 }}>Schedina vinta ✓</div>
      <div style={{ fontSize: 40, fontWeight: 800, marginTop: 8 }}>{slip.label || `Schedina quota ${slip.target}`}</div>
      <div style={{ display: "flex", alignItems: "baseline", gap: 24, marginTop: 24 }}>
        <div style={{ fontSize: 150, fontWeight: 900, color: "#39FF14", lineHeight: 1 }}>{slip.total_odds.toFixed(2)}</div>
        <div style={{ fontSize: 30, color: "#A1A1AA" }}>quota · {slip.selections.length} eventi</div>
      </div>
      <div style={{ marginTop: 48, borderTop: "2px solid #27272A" }}>
        {slip.selections.map((x) => (
          <div key={x.match_id + x.market} style={{ display: "flex", alignItems: "center", gap: 20, padding: "20px 0", borderBottom: "2px solid #1A1A1A" }}>
            <div style={{ width: 40, height: 40, borderRadius: 20, background: "#39FF14", color: "#000", display: "grid", placeItems: "center", fontWeight: 900, fontSize: 26 }}>✓</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 30, fontWeight: 800, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{x.home} - {x.away}</div>
              <div style={{ fontSize: 24, color: "#A1A1AA" }}>{x.market_label}{x.final_score ? ` · ${x.final_score}` : ""}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 48, fontSize: 30, fontWeight: 800 }}>Pronostici e schedine AI ogni giorno su <span style={{ color: "#39FF14" }}>{window.location.host}</span></div>
      <div style={{ marginTop: 12, fontSize: 20, color: "#71717A" }}>Il gioco è vietato ai minori e può causare dipendenza.</div>
    </div>
  );
}

export function ShareSlipButton({ slip, date }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const share = async () => {
    setBusy(true);
    try {
      const url = await toPng(ref.current, { pixelRatio: 1, cacheBust: true });
      const blob = await (await fetch(url)).blob();
      const file = new File([blob], `goalai-quota-${slip.total_odds.toFixed(2)}.png`, { type: "image/png" });
      const text = `Schedina vinta a quota ${slip.total_odds.toFixed(2)} con GOAL.AI ✅ ${window.location.origin}`;
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text, title: "GOAL.AI" });
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = file.name;
        a.click();
        toast.success("Immagine scaricata: condividila su WhatsApp o Instagram");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Impossibile creare l'immagine, riprova");
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <button onClick={share} disabled={busy} data-testid={`share-slip-${slip.id || slip.target}`}
        className="mt-4 w-full flex items-center justify-center gap-2 bg-[#39FF14] text-black font-black uppercase tracking-wider text-xs py-3 hover:bg-white transition-colors disabled:opacity-60">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Share2 size={14} />} Condividi la vincita
      </button>
      <div style={{ position: "fixed", left: -10000, top: 0, pointerEvents: "none" }} aria-hidden>
        <div ref={ref}><ShareCard slip={slip} date={date} /></div>
      </div>
    </>
  );
}
